import SectionHeading from "@/components/base/SectionHeading";
import { patientJourney } from "@/mocks/site";

/**
 * "Patient journey" — five connected steps laid out horizontally on desktop
 * and stacked vertically on smaller screens.
 */
export default function PatientJourney() {
  return (
    <section className="bg-gradient-to-b from-background-50 to-primary-50/50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Patient Journey"
          title="What to expect, from first visit to recovery"
          description="A clear, supported pathway so you always know the next step in your care."
        />

        <div className="reveal relative mt-14">
          <div
            className="absolute left-[10%] right-[10%] top-8 hidden h-0.5 bg-gradient-to-r from-primary-300 via-secondary-300 to-accent-300 md:block"
            aria-hidden="true"
          ></div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-5 md:gap-4">
            {patientJourney.map((step, index) => (
              <div key={step.step} className="relative flex flex-col items-center text-center">
                <span className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full border border-background-200 bg-background-50 font-heading text-lg font-semibold text-primary-700 shadow-[0_16px_36px_-24px_rgba(15,40,80,0.55)]">
                  {step.step}
                  <span
                    className={`absolute inset-0 -z-10 rounded-full opacity-60 blur-md ${
                      index % 3 === 0 ? "bg-primary-200" : index % 3 === 1 ? "bg-secondary-200" : "bg-accent-200"
                    }`}
                    aria-hidden="true"
                  ></span>
                </span>
                <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 max-w-[15rem] font-body text-sm leading-relaxed text-foreground-600">{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}